<template>
  <section>
    <div class="container">
      <h2>자주 묻는 질문</h2>

      <div class="faq-list">
        <div 
          :class="[
            'faq-item',
            {
              opened: opened.includes(i)
            }
          ]" 
          v-for="faq, i in faqs"
          :key="i"
        >
          <div 
            class="faq-item-head"
            v-on:click="toggle(i)"
          > 
            <div class="bullet"></div>
            <h4>{{faq.title}}</h4>

            <button
            >
              <svgChevronUp 
                v-if="opened.includes(i)"
              />
              <svgChevronDown 
                v-else
              />
            </button>
          </div>
          <div class="faq-item-body" v-if="opened.includes(i)">
            <p v-html="faq.answer"></p>
            <span v-if="faq.disclaimer" v-html="faq.disclaimer"></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import svgChevronUp from '@/svg/svgChevronUp'
import svgChevronDown from '@/svg/svgChevronDown'
export default {
  data() {
    return {
      opened: [],
      faqs: [
        {
          title: "채팅+ OGQ마켓은 어떤 서비스인가요?",
          answer: `
            채팅+ OGQ마켓은 통신 3사인 SKT, KT, LGU+와 원스토어 공동으로 구축 및 운영하는<br>
            새로운 문자메시지 이모티콘 판매 마켓으로 마켓에서 구매 한 이모티콘은 채팅+ 에서 더 재미있고 알찬 대화를 나눌 때 사용 가능해요.
          `
        },
        {
          title: "채팅+ OGQ마켓을 이용하고 싶어요.",
          answer: `
            채팅+ OGQ마켓은 안드로이드 단말기에서 이용 가능하며,
            '삼성 '갤럭시 Z 플립4'와 '갤럭시 Z 폴드4' 를 시작으로 향후 다양한 안드로이드 단말기에서 서비스될 예정이며, 최초 실행 시 원스토어 가입/인증 진행 후 마켓을 이용하 실 수 있어요.
          `,
          disclaimer: `
            (타 기종의 경우 순차적으로 펌웨어 / 앱 업데이트를 통해 이용 가능할 예정입니다.)
          `
        },
        {
          title: "채팅+ OGQ마켓에서 구매한 이모티콘은 어디에서 이용할 수 있나요?",
          answer: `
            구매하신 이모티콘은 안드로이드 단말기의  채팅+ 에서 사용 가능해요.
          `
        },
        {
          title: "이모티콘은 어떻게 사용하나요?",
          answer: `
            채팅+ 실행 후 대화창에서 사용 가능합니다. 추가로 더 많은 이모티콘을 사용하려면 채팅+ OGQ마켓에서  다운로드 받은 후 이모티콘을 사용하실 수 있어요.
          `
        },
        {
          title: "채팅+ OGQ마켓 이모티콘을 선물할 수 있나요?",
          answer: `
            현재는 이모티콘 선물하기 기능을 제공하지 않습니다.
          `,
          disclaimer: `
            (추후 업데이트를 통해 선물하기 기능을 지원 예정입니다.)
          `
        },
        {
          title: "아이폰 사용자는 이용할 수 없나요?",
          answer: `
            현재 채팅+ OGQ마켓은 안드로이드 단말기에서만 사용 가능합니다.
          `
        },
      ]
    }
  },
  methods: {
    toggle(index) {
      if (this.opened.includes(index)){
        this.opened.splice(this.opened.indexOf(index), 1)
      } else {
        this.opened.push(index)
      }
    }
  },
  components: {
    svgChevronDown,
    svgChevronUp
  }
}
</script>

<style lang="scss" scoped>

section {
  --faq-question-font-size: 18px;
  padding: 70px 0;

  @media screen and (max-width: 768px) {
    --faq-question-font-size: 15px;
  }
  @media screen and (max-width: 600px) {
    padding: 50px 0;
  }
}

h2 {
  text-align: center;
  font-size: 28px;
  line-height: 35px;
  font-weight: 700;
  color: #171717;
  margin-bottom: 40px;
  @media screen and (max-width: 600px) {
    font-size: 22px;
  }
}

.faq-list {
  border-top: 3px solid black;
  border-bottom: 3px solid black;
}

.faq-item {
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
}
.faq-item-head {
  display: flex;
  align-items: center;
  padding: 20px 25px;
  color: #3C3C3C;
  .opened & {
    color: #3B7CF3;
  }
  @media screen and (max-width: 768px) {
    padding: 20px 10px;
    padding-right: 10px;
  }
  @media screen and (max-width: 540px) {
    padding-right: 0;
  }
}
.faq-item + .faq-item {
  border-top-color: black;
}
.faq-item.opened + .faq-item {
  border-top-color: transparent;
}

.faq-item-head h4 {
  font-size: var(--faq-question-font-size);  
}

.faq-item-head .bullet {
  flex: none;
  width: 7px;
  height: 7px;
  background-color: #3C3C3C;
  border-radius: 50%;
  margin-right: 10px;
  .opened & {
    background-color: #3B7CF3;
  }
}

.faq-item-head button {
  cursor: pointer;
  flex: none;
  background-color: transparent;
  outline: 0;
  border: 0;
  width: 33px;
  height: 33px;
  margin-left: auto;
  color: #3C3C3C;
  svg {
    display: block;
    width: 100%;
    height: auto;
    fill: currentColor;
  }
  @media screen and (max-width: 600px) {
    width: 25px;
    height: 25px;
  }
}

.faq-item.opened .faq-item-head button {
  color: #3B7CF3;
}

.faq-item-body {
  background-color: #FAFAFA;
  padding: 30px 59px 30px 34px;
  color: #3A3A3A;
  font-weight: 400px;
  line-height: 22px;
  word-break: keep-all;
  @media screen and (max-width: 768px) {
    padding: 20px 30px 20px 20px;
  }
  @media screen and (max-width: 600px) {
    font-size: 15px;
  }
  span {
    display: block;
    font-size: 14px;
    color: #6B6B6B;
  }
}

</style>